import React from "react";
import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import ListAltIcon from "@material-ui/icons/ListAlt";
import products from "../../service/products";
import { getTenant } from "../../libs/tenant";
import GroupDialog from "./GroupDialog";
import ConfirmDialog from "../alertas/Confirm";
import SuccessAlert from "../alertas/SuccessAlert";

// Lista os Grupos de Produtos (catálogos) da empresa. Abrir um grupo -> props.onOpen(group).
// Props: enterpriseId, onOpen(group).
class GroupList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { title: "id", field: "id", hidden: true },
        { title: "Nome", field: "name" },
        { title: "Descrição", field: "description" },
        {
          title: "Ativo",
          field: "active",
          render: (row) => (row.active ? "Sim" : "Não"),
        },
      ],
      data: [],
      loading: false,
      openDialog: false,
      editingGroup: null,
      confirmDelete: null,
      successMessage: "",
    };
  }

  componentDidMount() {
    this.getGroups();
  }

  getGroups = () => {
    this.setState({ loading: true });
    products
      .listGroups(getTenant())
      .then((data) => this.setState({ data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  };

  handleSaveDialog = (message) => {
    this.setState({
      openDialog: false,
      editingGroup: null,
      successMessage: message,
    });
    this.getGroups();
  };

  deleteGroup = () => {
    const group = this.state.confirmDelete;
    products.deleteGroup(group.id).then(() => {
      this.setState({ confirmDelete: null, successMessage: "Grupo excluído." });
      this.getGroups();
    });
  };

  render() {
    return (
      <Paper>
        {this.state.openDialog && (
          <GroupDialog
            enterpriseId={this.props.enterpriseId}
            group={this.state.editingGroup}
            close={() => this.setState({ openDialog: false, editingGroup: null })}
            save={() =>
              this.handleSaveDialog(
                this.state.editingGroup ? "Grupo atualizado." : "Grupo criado."
              )
            }
          />
        )}
        {this.state.confirmDelete && (
          <ConfirmDialog
            title="Atenção"
            body={`Deseja excluir o grupo "${this.state.confirmDelete.name}"?`}
            handleCloseConfirmT={this.deleteGroup}
            handleCloseConfirmF={() => this.setState({ confirmDelete: null })}
          />
        )}
        <SuccessAlert
          open={!!this.state.successMessage}
          message={this.state.successMessage}
          onClose={() => this.setState({ successMessage: "" })}
        />
        <MaterialTable
          title="Grupo de Produtos"
          columns={this.state.columns}
          data={this.state.data}
          isLoading={this.state.loading}
          options={{ search: true, actionsColumnIndex: -1 }}
          actions={[
            {
              icon: () => <AddIcon />,
              tooltip: "Novo grupo",
              isFreeAction: true,
              onClick: () => this.setState({ openDialog: true, editingGroup: null }),
            },
            {
              icon: () => <ListAltIcon />,
              tooltip: "Todos os produtos da empresa",
              isFreeAction: true,
              onClick: () => this.props.onViewAll(),
            },
            {
              icon: () => <OpenInNewIcon />,
              tooltip: "Abrir",
              onClick: (event, row) => this.props.onOpen(row),
            },
            {
              icon: () => <EditIcon />,
              tooltip: "Editar",
              onClick: (event, row) =>
                this.setState({ openDialog: true, editingGroup: row }),
            },
            {
              icon: () => <DeleteIcon />,
              tooltip: "Excluir",
              onClick: (event, row) => this.setState({ confirmDelete: row }),
            },
          ]}
        />
      </Paper>
    );
  }
}

export default GroupList;
